'use client';
import styled from 'styled-components';

export const SubtitleHeading = styled.p`
  text-align: center;
  max-width: 688px;
  margin: ${props => props.theme.spacing(2)} auto 0;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
  padding-top: ${props => props.theme.spacing(6)};
  padding-bottom: ${props => props.theme.spacing(10)};
  @media ${props => props.theme.tablet} {
    padding-top: ${props => props.theme.spacing(2)};
    padding-bottom: ${props => props.theme.spacing(14)};
    ${props => props.theme.typography.body};
  }
`;

export const Subtext = styled.p`
  text-align: center;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
`;

export const ButtonContainer = styled.div`
  margin: auto;
  max-width: 512px;
  display: grid;
  text-align: center;
  width: 100%;
  gap: ${props => props.theme.spacing(4)};
  padding: ${props => props.theme.spacing(16, 4, 40)};
  @media ${props => props.theme.mobileS} {
    gap: ${props => props.theme.spacing(6)};
    padding: ${props => props.theme.spacing(2, 4, 24)};
  }
`;

export const AddOnForm = styled.form`
  margin-bottom: ${props => props.theme.spacing(30)};
`;

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${props => props.theme.spacing(4)} auto;

  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(6)} auto;
  }
`;
